module.exports = __webpack_public_path__ + "img/V6.be1843b6.png";